import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import AuthPageContainer from "@/features/auth/containers/auth-page-container";
import { beforeGuestGuard } from "@/features/auth/guards";

const signinSearchSchema = z.object({
  redirect: z.string().optional(),
});

function SigninPage() {
  return <AuthPageContainer mode="signin" />;
}

// Inferred child route: /signin
export const Route = createFileRoute("/signin")({
  beforeLoad: beforeGuestGuard,
  ssr: false,
  validateSearch: (search) => signinSearchSchema.parse(search),
  component: SigninPage,
});
